import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';

import './IconButton.css';
import ajaxSpinner from '../../assets/ajax-loader.gif';

const IconButton = (props) => {
  const {
    onClick,
    label,
    baseIcon,
    activatedIcon,
    isActivated,
    isLoading
  } = props;

  return (
    <button
      styleName={`button ${isActivated ? 'activated-button' : ''}`}
      onClick={onClick}
      type="button"
      disabled={isLoading}
    >
      {baseIcon && activatedIcon && !isLoading && (
        <Icon
          icon={isActivated ? activatedIcon : baseIcon}
          isActivated={isActivated}
        />
      )}
      {isLoading && (
        <img src={ajaxSpinner} alt="Spinner" styleName="loading-spinner" />
      )}
      <span styleName="inner">{label}</span>
    </button>
  );
};

IconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  baseIcon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  activatedIcon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  isActivated: PropTypes.bool,
  isLoading: PropTypes.bool
};

IconButton.defaultProps = {
  baseIcon: null,
  activatedIcon: null,
  isActivated: false,
  isLoading: false
};

export default IconButton;
